/* Funtastic — arte e movimento */
(function(){
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var clamp = function(v,a,b){return Math.max(a,Math.min(b,v));};
  var raf = window.requestAnimationFrame.bind(window);

  function initTop(){
    var b = document.body;
    if (!b.classList.contains('t-index') || !document.querySelector('.at-hero')){ b.removeAttribute('data-top'); return; }
    var set = function(){ if (window.scrollY < 40) b.setAttribute('data-top',''); else b.removeAttribute('data-top'); };
    set(); window.addEventListener('scroll', set, {passive:true});
  }

  function initVideo(){
    document.querySelectorAll('[data-at-video]').forEach(function(v){
      var src = (window.innerWidth < 750 && v.dataset.lo) ? v.dataset.lo : v.dataset.hi;
      if (!src) return;
      v.src = src; v.muted = true;
      var p = v.play(); if (p && p.catch) p.catch(function(){});
    });
  }

  /* Teto de favos de luz, como no stand */
  function Hex(canvas){
    var mode = canvas.dataset.atHex || 'night';
    var ctx = canvas.getContext('2d');
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var R = mode === 'hero' ? 70 : 52;
    var W=0,H=0,cells=[],px=-9999,py=-9999,tx=-9999,ty=-9999,lastMove=0,visible=false,t0=performance.now(),running=false;
    var host = canvas.parentElement;
    function build(){
      var r = host.getBoundingClientRect();
      W = r.width; H = r.height;
      canvas.width = Math.round(W*dpr); canvas.height = Math.round(H*dpr);
      cells = [];
      var w = Math.sqrt(3)*R, h = 1.5*R;
      for (var row=-1; row*h < H+R*2; row++){
        for (var col=-1; col*w < W+w; col++){
          var cx = col*w + (row%2 ? w/2 : 0), cy = row*h;
          cells.push({x:cx,y:cy,lit:Math.random()<(mode==='night'?.22:0)?1:0,ph:Math.random()*6.28,v:0});
        }
      }
    }
    var vx=[],vy=[];
    for (var i=0;i<6;i++){ var a = Math.PI/180*(60*i-30); vx.push(Math.cos(a)); vy.push(Math.sin(a)); }
    function draw(now){
      var t = (now - t0)/1000;
      if (now - lastMove > 2600){ tx = W*(.5+.38*Math.sin(t*.23)); ty = H*(.5+.34*Math.sin(t*.31+1.3)); }
      px += (tx-px)*.08; py += (ty-py)*.08;
      ctx.setTransform(dpr,0,0,dpr,0,0);
      ctx.clearRect(0,0,W,H);
      ctx.lineCap = 'round';
      var sig = R*(mode==='hero'?2.2:2.8), s2 = 2*sig*sig;
      for (var k=0;k<cells.length;k++){
        var c = cells[k];
        var dx = c.x-px, dy = c.y-py;
        var g = Math.exp(-(dx*dx+dy*dy)/s2);
        var base = mode==='hero' ? 0 : 0.06 + 0.05*(0.5+0.5*Math.sin(t*.7 + c.x*.004 + c.y*.006));
        var tgt = clamp(base + g*(mode==='hero'?.55:1) + (c.lit && mode==='night' ? .22+.12*Math.sin(t*1.3+c.ph) : 0), 0, 1);
        c.v += (tgt - c.v)*.12;
        var a = c.v; if (a < .02) continue;
        var gap = .16, r = R*.94;
        ctx.beginPath();
        for (var e=0;e<6;e++){
          var e2 = (e+1)%6;
          var x1 = c.x+vx[e]*r, y1 = c.y+vy[e]*r, x2 = c.x+vx[e2]*r, y2 = c.y+vy[e2]*r;
          ctx.moveTo(x1+(x2-x1)*gap, y1+(y2-y1)*gap);
          ctx.lineTo(x2-(x2-x1)*gap, y2-(y2-y1)*gap);
        }
        if (a > .25){ ctx.lineWidth = 9; ctx.strokeStyle = 'rgba(255,255,255,'+(a*.07).toFixed(3)+')'; ctx.stroke(); ctx.lineWidth = 4.5; ctx.strokeStyle = 'rgba(255,255,255,'+(a*.14).toFixed(3)+')'; ctx.stroke(); }
        ctx.lineWidth = 1.8; ctx.strokeStyle = 'rgba(255,255,255,'+a.toFixed(3)+')'; ctx.stroke();
      }
      if (visible && !RM && !document.hidden) raf(draw); else running = false;
    }
    function start(){ if (!running && visible && !RM){ running = true; raf(draw); } }
    function onMove(e){
      var r = canvas.getBoundingClientRect();
      if (e.clientY < r.top || e.clientY > r.bottom) return;
      tx = e.clientX - r.left; ty = e.clientY - r.top; lastMove = performance.now();
    }
    build(); px = tx = W/2; py = ty = H/2;
    window.addEventListener('pointermove', onMove, {passive:true});
    var to; window.addEventListener('resize', function(){ clearTimeout(to); to = setTimeout(function(){ build(); if (RM) draw(performance.now()); }, 150); });
    document.addEventListener('visibilitychange', start);
    new IntersectionObserver(function(en){ visible = en[0].isIntersecting; start(); }).observe(canvas);
    if (RM) setTimeout(function(){ draw(performance.now()+9999); }, 50);
  }

  /* Garagem: scroll vertical vira viagem horizontal */
  function initGarage(){
    document.querySelectorAll('[data-at-garage]').forEach(function(sec){
      var tr = sec.querySelector('[data-track]'), bar = sec.querySelector('[data-bar]'), cnt = sec.querySelector('[data-count]');
      var cars = tr.querySelectorAll('.at-car'), dist = 0, on = false, tick = false;
      var upd = function(){
        tick = false; if (!on) return;
        var r = sec.getBoundingClientRect(), p = dist ? clamp(-r.top/dist,0,1) : 0;
        tr.style.transform = 'translate3d(' + (-p*dist).toFixed(1) + 'px,0,0)';
        if (bar) bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        if (cnt){ var i = Math.min(cars.length, Math.floor(p*cars.length)+1); cnt.textContent = String(i).padStart(2,'0') + ' / ' + String(cars.length).padStart(2,'0'); }
      };
      var size = function(){
        on = window.innerWidth >= 750 && !RM;
        if (!on){ sec.style.height = ''; tr.style.transform = ''; return; }
        dist = Math.max(0, tr.scrollWidth - tr.clientWidth);
        sec.style.height = (window.innerHeight + dist) + 'px';
        upd();
      };
      window.addEventListener('scroll', function(){ if (!tick){ tick = true; raf(upd); } }, {passive:true});
      var to; window.addEventListener('resize', function(){ clearTimeout(to); to = setTimeout(size, 120); });
      window.addEventListener('load', size);
      size();
    });
  }

  /* Página de modelo: o nome em grande, atrás do carro */
  function ghost(){
    var n = document.querySelector('.fs-buy__name');
    if (!n) return;
    document.querySelectorAll('.fs-stage').forEach(function(st){
      if (st.querySelector('.at-ghost') || st.closest('.fs-sec')) return;
      var g = document.createElement('span');
      g.className = 'at-ghost'; g.setAttribute('aria-hidden','true');
      g.textContent = n.textContent.trim().split(/\s+/)[0];
      st.insertBefore(g, st.firstChild);
    });
  }
  function initGhost(){
    ghost();
    var m = document.querySelector('[data-fs-model]'); if (!m || !m.parentNode) return;
    var to; new MutationObserver(function(){ clearTimeout(to); to = setTimeout(ghost, 30); }).observe(m.parentNode, {childList:true, subtree:true});
  }

  function init(){
    initTop(); initVideo(); initGarage(); initGhost();
    document.querySelectorAll('canvas[data-at-hex]').forEach(function(c){ try { Hex(c); } catch(e){} });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
